import { useCallback } from 'react';
export var assignRef = function (ref, el) {
    if (typeof ref === 'function') {
        ref(el);
    }
    else {
        ref.current = el;
    }
};
/**
 * Combines multiple React Refs into a single Ref that can be
 * passed to an element, which will update all provided Refs.
 */
// @ts-nocheck
var useCombinedRef = function () {
    var refs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        refs[_i] = arguments[_i];
    }
    var finalRef = useCallback(function (el) {
        refs.forEach(function (ref) {
            if (ref) {
                assignRef(ref, el);
            }
        });
    }, refs);
    return finalRef;
};
export default useCombinedRef;
//# sourceMappingURL=useCombinedRef.js.map